import { render, staticRenderFns } from "./apply-to-join.vue?vue&type=template&id=78cb63c4"
import script from "./apply-to-join.vue?vue&type=script&lang=js"
export * from "./apply-to-join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports